// src/com/file_of_report/TransPlanReportGql.js
import { gql } from "@apollo/client";

/*
# trans_plan_report.graphqls

extend type Mutation {
    transPlanReportAdd(transPlanReport: InputTransPlanReportAdd!): ResponseWithFileCreateHisItem!
}

# 운송요청 레포트 조회용 입력.
input InputTransPlanReportAdd {
    timeFrom: String!
    timeTill: String!
    reqStateFlag: String
}

*/

export const CREATE_TRANS_PLAN_REPORT = gql`
mutation CreateTransPlanReport($transPlanReport:InputTransPlanReportAdd!) {
    transPlanReportAdd(transPlanReport: $transPlanReport) {
        ok
        message
        item {
            fileCreateHisSeq
        }
    }
}
`;

